import type { TranslationModule } from '../types';

export const cedoSectionTranslations: TranslationModule = {
  ro: {
    badge: "NOU & INTEGRAT",
    title: "Biblioteca CEDO & Fișe Practice",
    subtitle: "Baza de date completă cu peste 1.100 de hotărâri CEDO traduse, ghiduri practice de admisibilitate și fișe tematice pe materii. Argumentează-ți cererile cu standardele Curții de la Strasbourg.",
    checklist: [
      "Fișe practice pe materii (Penal, Penitenciare, Viață, Sănătate etc.)",
      "Peste 1.090 de cauze CEDO împotriva României traduse și rezumate",
      "Ghiduri oficiale de admisibilitate și ghiduri pe articole din Convenție",
      "Handbooks, manuale de drept comparat și rapoarte practice",
      "Vizualizare online securizată și descărcare în format Word (.docx)"
    ],
    btnCTA: "Explorează Biblioteca CEDO",
    btnMore: "Fișe de Jurisprudență",
    cards: {
      sync: {
        title: "Argumentare rapidă în instanță",
        desc: "<strong>1. Căuți articolele</strong> sau temele de interes. <br /><strong>2. Analizezi fișele practice</strong> dedicate pe categorii. <br /><strong>3. Descarci formatul Word</strong> pentru a-l integra direct în cererile tale."
      },
      portal: {
        title: "Hotărâri împotriva României",
        desc: "Afișăm rezumate detaliate, numărul cererii, data deciziei, data publicării în Monitorul Oficial, legislația românească incidentă și despăgubirile acordate sub formă de satisfacție echitabilă."
      },
      search: {
        title: "Filtrare după articole și materii",
        desc: "Găsești instant cauzele relevante filtrând după articolele din Convenție (ex: Art. 3, Art. 6, Art. 8) sau după materia incidentă (Civil, Penal, Drepturi Administrative etc.)."
      },
      party: {
        title: "Prevenirea inadmisibilității",
        desc: "Peste 90% din cererile la CEDO sunt respinse ca inadmisibile. Ghidurile oficiale pe articole și Ghidul Practic de Admisibilitate te ajută să formulezi cereri corecte din punct de vedere procedural."
      },
      alerts: {
        title: "Fișe Practice pe Domenii",
        desc: "Acces direct la fișe de jurisprudență pe probleme de maxim interes: condiții de detenție, dreptul la viață, sănătate, nediscriminare, protecția minorilor, exproprieri și viață de familie."
      }
    },
    benefits_title: "AVANTAJE LEGEAAPLICATĂ",
    benefits: [
      "Traducere în română & sinteze clare",
      "Format Word (.docx) gata de descărcat",
      "Interfață complet optimizată pe mobil"
    ],
    security: "Securizat & Privat"
  },
  en: {
    badge: "NEW & INTEGRATED",
    title: "ECHR Library & Practical Factsheets",
    subtitle: "Complete database with over 1,100 translated ECHR judgments, practical admissibility guides, and thematic factsheets. Build your legal arguments using Strasbourg Court standards.",
    checklist: [
      "Practical factsheets by subject (Criminal, Prisons, Life, Health, etc.)",
      "Over 1,090 translated and summarized ECHR cases against Romania",
      "Official admissibility guides and article-by-article handbooks",
      "Handbooks, comparative law manuals, and practical reports",
      "Secure online viewing and Word (.docx) format downloads"
    ],
    btnCTA: "Explore ECHR Library",
    btnMore: "Jurisprudence Factsheets",
    cards: {
      sync: {
        title: "Quick Court Argumentation",
        desc: "<strong>1. Search articles</strong> or topics of interest. <br /><strong>2. Analyze practical sheets</strong> dedicated by category. <br /><strong>3. Download Word files</strong> to integrate directly into your applications."
      },
      portal: {
        title: "Judgments Against Romania",
        desc: "We display detailed summaries, application number, decision date, Official Gazette publication date, relevant Romanian legislation, and just satisfaction damages awarded."
      },
      search: {
        title: "Filter by Articles and Subjects",
        desc: "Instantly find relevant cases by filtering by Convention articles (e.g., Art. 3, Art. 6, Art. 8) or by applicable subject (Civil, Criminal, Administrative Rights, etc.)."
      },
      party: {
        title: "Preventing Inadmissibility",
        desc: "Over 90% of ECHR applications are declared inadmissible. Official article guides and the Practical Guide on Admissibility Criteria help you file procedurally correct complaints."
      },
      alerts: {
        title: "Practical Thematic Sheets",
        desc: "Direct access to case-law sheets on subjects of high interest: detention conditions, right to life, health, non-discrimination, child protection, and family life."
      }
    },
    benefits_title: "LEGEAAPLICATA ADVANTAGES",
    benefits: [
      "Romanian translations & clear summaries",
      "Word (.docx) format ready to download",
      "Fully mobile-optimized responsive interface"
    ],
    security: "Secure & Private"
  },
  fr: {
    badge: "NOUVEAU & INTÉGRÉ",
    title: "Bibliothèque CEDH & Fiches Pratiques",
    subtitle: "Base de données complète avec plus de 1 100 arrêts de la CEDH traduits, guides pratiques de recevabilité et fiches thématiques. Argumentez vos demandes selon les normes de la Cour de Strasbourg.",
    checklist: [
      "Fiches pratiques par matière (Pénal, Prisons, Vie, Santé, etc.)",
      "Plus de 1 090 affaires CEDH contre la Roumanie traduites et résumées",
      "Guides officiels de recevabilité et guides par article de la Convention",
      "Manuels de droit comparé, guides de la CEDH et rapports pratiques",
      "Visualisation en ligne sécurisée et téléchargement au format Word (.docx)"
    ],
    btnCTA: "Explorer la bibliothèque CEDH",
    btnMore: "Fiches de Jurisprudence",
    cards: {
      sync: {
        title: "Argumentation rapide en justice",
        desc: "<strong>1. Recherchez les articles</strong> ou thèmes d'intérêt. <br /><strong>2. Analysez les fiches</strong> thématiques dédiées par catégorie. <br /><strong>3. Téléchargez au format Word</strong> pour l'intégrer directement dans vos requêtes."
      },
      portal: {
        title: "Arrêts contre la Roumanie",
        desc: "Nous affichons des résumés détaillés, le numéro de requête, la date de décision, la publication au Journal Officiel, la législation interne et la satisfaction équitable accordée."
      },
      search: {
        title: "Filtrer par articles et matières",
        desc: "Trouvez instantanément les affaires de la CEDH en filtrant par articles de la Convention (ex: Art. 3, Art. 6, Art. 8) ou par matière (Civil, Pénal, Administratif, etc.)."
      },
      party: {
        title: "Prévenir l'irrecevabilité",
        desc: "Plus de 90% des requêtes devant la CEDH sont rejetées comme irrecevables. Les guides officiels et le Guide pratique sur la recevabilité vous aident à formuler des requêtes correctes."
      },
      alerts: {
        title: "Fiches thématiques pratiques",
        desc: "Accès direct aux fiches de jurisprudence sur des sujets d'intérêt majeur : conditions de détention, droit à la vie, santé, non-discrimination, protection de l'enfance."
      }
    },
    benefits_title: "AVANTAGES LEGEAAPLICATA",
    benefits: [
      "Traductions en roumain & résumés clairs",
      "Format Word (.docx) prêt à télécharger",
      "Interface réactive entièrement optimisée pour mobile"
    ],
    security: "Sécurisé & Privé"
  }
};

export default cedoSectionTranslations;
